import { CustomVizDefinition } from 'libs/end-to-end/src/custom-viz-definition';
import { TableViewOutput } from 'libs/end-to-end/src/custom-viz/TableViewTypes';

export const TableViewCustomVizDefinition: CustomVizDefinition = {
  customVizId: 'tableView',
  isDataQueuingAllowed: true,
  outputFileName: 'table_view_output.json',
  outputSchema: TableViewOutput,
  resolveFocusArea: () => null,
  resolveFilters: (request) => {
    if (request.customVizId !== 'tableView') {
      throw new Error('Invalid custom viz ID');
    }
    return request.inputs.extras.filters;
  },
  resolveAnalysisName: () => undefined,
  checkEnoughDataStateEnabledGate: false,
  eventProperties: (request) => {
    if (request.customVizId !== 'tableView') {
      throw new Error('Invalid custom viz ID');
    }
    return {
      'Custom Viz Type': request.customVizId,
      'Selected Dimensions': [],
      'Selected Metrics': [],
      'Selected Focus Areas': [],
      Filters: request.inputs.extras.filters,
    };
  },
  getUrlPath: () => 'explore/table-view',
};
